/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
import { useElementSize, useListState } from '@mantine/hooks';
import { FC, useEffect, useState } from 'react';
import { Text } from '@mantine/core';
import BookitupTable from '../../../Atoms/BookitupTable';
import { WorkflowDTO } from '../../../Types/LogT';
import { WorkflowS } from '../../../Service/WorkflowS';
import { openDeleteConfirmModal } from '../../../Atoms/DeleteConfirmModal';
import EmptyText from '../../../Atoms/EmptyText';
import EventWorkflowListItem from './EventWorkflowListItem';

const EventWorkflowList: FC<{ workflowTemplateId: string }> = ({ workflowTemplateId }) => {
  const { ref } = useElementSize();
  const [loading, setLoading] = useState(false);
  const [workflows, handlers] = useListState<WorkflowDTO>([]);
  const { setState: setWorkflows } = handlers;
  const { length } = workflows;

  useEffect(() => {
    setLoading(true);
    WorkflowS.fetchWorkflowsByTemplate(workflowTemplateId)
      .then(setWorkflows)
      .finally(() => setLoading(false));
  }, [setWorkflows, workflowTemplateId]);

  const deleteAll = () => {
    const onConfirm = async () => {
      const removed = await WorkflowS.deleteAllWorkflowsByTemplateId(workflowTemplateId);
      if (removed) {
        setWorkflows([]);
      }
      return removed;
    };
    openDeleteConfirmModal({
      title: 'Wirklich löschen?',
      description: 'Möchtest du wirklich diesen Workflow von allen Event entfernen?',
      onConfirm,
    });
  };

  return (
    <div ref={ref}>
      <BookitupTable>
        <thead>
          <tr>
            <th>Workflow-Name im Event</th>
            <th style={{ width: 235 }}>Event</th>
            <th>
              {length > 0 && (
                <Text size="xs" color="red" align="right" onClick={deleteAll} variant="link" sx={{ cursor: 'pointer' }}>
                  Alle löschen
                </Text>
              )}
            </th>
          </tr>
        </thead>
        <tbody>
          {!loading && length === 0 && <EmptyText />}
          {workflows.map((workflow: WorkflowDTO, idx) => (
            <EventWorkflowListItem idx={idx} workflow={workflow} key={workflow.eventId} handlers={handlers} />
          ))}
        </tbody>
      </BookitupTable>
    </div>
  );
};

export default EventWorkflowList;
